<template>
  <div
    id="app"
    class="outsider"
  >
    <el-card class="index-card">
      <div slot="header">
        广联运营平台
      </div>
      <ul>
        <li>
          <a
            href="../customer/customerService.html"
            target="_self"
          >
            客服管理
          </a>
        </li>
 <li>
          <a
            href="../customer/officialAccount.html"
            target="_self"
          >
            公众号配置
          </a>
        </li>
        <li>
          <a
            href="../customer/collectionManagement.html"
            target="_self"
          >
            领用管理
          </a>
        </li>
        <li>
          <a
            href="../customer/rightsCardManagement.html"
            target="_self"
          >
            权益卡管理
          </a>
        </li>
        <li>
          <a
            href="../tao/gasManagement.html"
            target="_self"
          >
            加油订单
          </a>
        </li>
        <li>
          <a
            href="../tao/eManagement.html"
            target="_self"
          >
            e代驾订单
          </a>
        </li>
        <li>
          <a
            href="../tao/goods/index.html"
            target="_self"
          >
            商品管理
          </a>
        </li>
        <li>
          <a
            href="../tao/order/index.html"
            target="_self"
          >
            订单管理
          </a>
        </li>
        <li>
          <a
            href="../tao/sale/index.html"
            target="_self"
          >
            售后管理
          </a>
        </li>
        <li>
          <a
            href="../tao/financialManagement.html"
            target="_self"
          >
            财务管理
          </a>
        </li>
        <li>
          <a
            href="../equity/list.html"
            target="_self"
          >
            权益管理
          </a>
        </li>
      </ul>
    </el-card>
  </div>
</template>

<script>

export default {
  name: 'App'
}
</script>

<style scoped>
.outsider {
  background-color: #fff;
  padding: 20px 0px 40px 0px;
  /* margin: 20px 20px; */
}
</style>
